import { Injectable } from "@angular/core";
import { ICheckOutRegisterSession_FE } from "@vierkant-software/types__api";
import { FullSyncableServiceBase, SyncLoadedData } from "./sync.service";
import { environment } from "src/environments/environment";

export enum CheckOutRegisterSessionDetailLevel {
    default = 0,
}

type CheckOutRegisterSessionDetailType = {
    [CheckOutRegisterSessionDetailLevel.default]: Partial<ICheckOutRegisterSession_FE>;
};
type CheckOutRegisterSessionLoadedData = SyncLoadedData<CheckOutRegisterSessionDetailType, CheckOutRegisterSessionDetailLevel>;

@Injectable({ providedIn: "root" })
export class CheckOutRegisterSessionSyncService extends FullSyncableServiceBase<CheckOutRegisterSessionDetailType, CheckOutRegisterSessionDetailLevel> {
    protected readonly syncName = "CheckOutRegisterSession";
    protected override get usesDeviceSession(): boolean {
        return environment.isCashRegister;
    }

    override getDefaultValue(): CheckOutRegisterSessionDetailType[CheckOutRegisterSessionDetailLevel] {
        return {};
    }

    // A rejected load would end the shared load pipeline of the base class for good.
    protected override async load(
        request: Record<string, CheckOutRegisterSessionDetailLevel>
    ): Promise<CheckOutRegisterSessionLoadedData[]> {
        return await super.load(request).catch((e: unknown): CheckOutRegisterSessionLoadedData[] => {
            console.warn('[CheckOutRegisterSessionSyncService] load failed:', e);
            return [];
        });
    }
}
